export default "__VITE_ASSET__C3FfFDD8__"